import { useLinkedContext } from '@context/LinkedItemZoneContext'

export function updateRightInfo(
  name: string,
  groupID: number,
  context: Omit<ReturnType<typeof useLinkedContext>, 'actions'>,
) {
  const name2 = name
  const group = groupID
  const context2 = context
  return { name2, group, context2 }
}
